export default __webpack_public_path__ + "static/media/sol-dvss-NuncaOuQuaseNunca.3fdcc954.jpeg";